import * as React from 'react';
const SvgFeaturedIcon = (props) => (
  <svg
    width={39}
    height={38}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.3}>
      <path
        d="M6.5 19C6.5 11.8203 12.3203 6 19.5 6C26.6797 6 32.5 11.8203 32.5 19C32.5 26.1797 26.6797 32 19.5 32C12.3203 32 6.5 26.1797 6.5 19Z"
        stroke="#F2994A"
        strokeWidth={2}
      />
    </g>
    <g opacity={0.1}>
      <path
        d="M1.5 19C1.5 9.05888 9.55888 1 19.5 1C29.4411 1 37.5 9.05888 37.5 19C37.5 28.9411 29.4411 37 19.5 37C9.55888 37 1.5 28.9411 1.5 19Z"
        stroke="#F2994A"
        strokeWidth={2}
      />
    </g>
    <g clipPath="url(#clip0_379_5917)">
      <path
        d="M19.4993 27.3337C24.1017 27.3337 27.8327 23.6027 27.8327 19.0003C27.8327 14.398 24.1017 10.667 19.4993 10.667C14.897 10.667 11.166 14.398 11.166 19.0003C11.166 23.6027 14.897 27.3337 19.4993 27.3337Z"
        stroke="#F2994A"
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 22.3333V19"
        stroke="#F2994A"
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 15.667H19.5083"
        stroke="#F2994A"
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_379_5917">
        <rect
          width={20}
          height={20}
          fill="white"
          transform="translate(9.5 9)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFeaturedIcon;
